// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__21WdM","description":"PatientConsentPreview_description__1so4t"};